import React, { useState, useEffect } from "react";
import axios from "axios";
import { useOutletContext, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
// import UploadResumeModal from "../../components/Modals/Candidate/UploadResume";
import toastr from "../../utils/toast";
import { useForm } from "react-hook-form";
import $ from "jquery";
import NewInterviewer from "../../components/Modals/workstation/NewInterviewer";
import CompensationAdd from "../../components/Modals/Candidate/CompensationAdd";
import ContributionForm from "../../components/Modals/workstation/ContributionForm";

function EditStatus() {
  const allSources = ["naukri", "headhunt", "others", "linkedin"];
  const { candidate_id, role_id, company_id, candidate_filter_id, filter_log_id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { token, setGlobalLoading } = useOutletContext();
  const [candidates, setCandidates] = useState({});
  const [majorFunctions, setMajorFunctions] = useState([]);
  const [selectedMajor, setSelectedMajor] = useState("");
  const [minorFunctions, setMinorFunctions] = useState([]);
  const [selectedMinorFunctions, setSelectedMinorFunctions] = useState([]);
  const [masterStatuses, setMasterStatuses] = useState([]);
  const [selectedMasterStatus, setSelectedMasterStatus] = useState("");
  const [candidateStatuses, setCandidateStatuses] = useState([]);
  const [candidateFilter, setCandidateFilter] = useState(null);
  const [files, setFiles] = useState("");
  const [timeZones, setTimeZones] = useState([]);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const {register, handleSubmit, setValue, watch, reset, formState: { errors },} = useForm();
  const newStatus = watch("new_status");
  const watchStatus = watch("candidate_status_id");
  const [compModel, setCompModel] = useState(false);
  const [Evaluation, setEvaluation] = useState(false);
  const [timediv, setTimediv] = useState(false);
  const [CandidateClosed, setCandidateClosed] = useState(false);
  const [showResume, setShowResume] = useState(false);
  const [ReqDossier, setReqDossier] = useState(false);
  const [showDossier, setShowDossier] = useState(false);
  const [LogData, setLogData] = useState([]);
  const [backgroundCheck, setBackgroundCheck] = useState(false);
  const [MeetingWith, setMeetingWith] = useState(false);
  const [meetingPlace, setMeetingPlace] = useState(false);
  const [newInterviewerModel, setNewInterviewerModel] = useState(false);
  const [HasComp, setHasComp] = useState(false);
  const [data, setData] = useState([]);
  const [CompReq, setCompReq] = useState(false);
  const [Contribution, setContribution] = useState(false);
  const [showContributionForm, setShowContributionForm] = useState(false);
  
  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/candidates/get_candidates_details/${candidate_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const cand = response.data.emp_detail[0].data;
        console.log("candiate detatils", cand);
        setCandidates(cand);
        setFormData((prev) => ({
          ...prev,
          email: cand.email || "",
          phone: cand.phone || "",
          gender: cand.gender || "",
        }));
        const filesBlock = response.data.emp_detail.find(
          (item) => item.key === "candidateResume"
        );
      
        if (filesBlock?.data) {
          setFiles(filesBlock.data);
        }
      } catch (error) {
        console.error("Error fetching candidate details:", error);
      } finally {
        setGlobalLoading(false);
      }
    }
    fetchOptions();
  }, [candidate_id]);

  useEffect(() => {
    async function fetchMajor() {
      setGlobalLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE_URL}/common_controller/get_major_functions`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setMajorFunctions(res.data.options || []);
      } catch (err) {
        console.error("Error fetching major functions:", err);
      } finally {
        setGlobalLoading(false);
      }
    }
    fetchMajor();
  }, []);

  useEffect(() => {
    if (candidates?.dutymaster && majorFunctions.length > 0) {
      const m = majorFunctions.find((mf) => mf.label === candidates.dutymaster);
      if (m) {
        setSelectedMajor(m.value);
      }
    }
  }, [candidates, majorFunctions]);

  useEffect(() => {
    async function fetchMinor() {
      if (!selectedMajor) return;
      setGlobalLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE_URL}/common_controller/get_minor_functions/${selectedMajor}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const opts = (res.data.minor_functions || []).map((f) => ({
          value: f.id,
          label: f.name,
        }));
        setMinorFunctions(opts);
        if (candidates?.duty_id) {
          const dutyIds = candidates.duty_id.split(",").map((id) => id.trim());
          const pre = opts.filter((o) => dutyIds.includes(String(o.value)));
          setSelectedMinorFunctions(pre);
        } else {
          setSelectedMinorFunctions([]);
        }
      } catch (err) {
        console.error("Error fetching minor functions:", err);
      } finally {
        setGlobalLoading(false);
      }
    }
    fetchMinor();
  }, [selectedMajor, candidates?.duties]);

  useEffect(() => {
    async function fetchMasterStatuses() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/common_controller/get_master_statuses`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setMasterStatuses(res.data.options || []);
      } catch (err) {
        console.error("Error fetching master statuses:", err);
      }
    }

    fetchMasterStatuses();
  }, []);

  useEffect(() => {
    if (!selectedMasterStatus) return;

    async function fetchCandidateStatuses() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/common_controller/get_child_statuses/${selectedMasterStatus}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setCandidateStatuses(res.data.options || []);
      } catch (err) {
        console.error("Error fetching child statuses:", err);
      }
    }

    fetchCandidateStatuses();
  }, [selectedMasterStatus]);

  useEffect(() => {
    async function fetchTimeZones() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/common_controller/get_timezone`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setTimeZones(res.data.options || []);
      } catch (err) {
        console.error("Error fetching time zones:", err);
      }
    }

    fetchTimeZones();
  }, []);

  useEffect(() => {
    async function fetchUsers() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/employeeinfos/getActiveUser`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setUsers(res.data.options || []);
      } catch (err) {
        console.error("Error fetching time zones:", err);
      }
    }

    fetchUsers();
  }, []);

  useEffect(() => {
    async function fetchLogs() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/candidates/get_candidates_logs/${candidate_id}/${role_id}/0`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const candidateFiltersItem = res.data.emp_logs.find(
          (item) => item.key === "candidateFilters"
        );

        const filterData =
          Array.isArray(candidateFiltersItem?.data) &&
          candidateFiltersItem.data.length > 0
            ? candidateFiltersItem.data[0]
            : null;
        setCandidateFilter(filterData);
        console.log(filterData);
        if (filterData?.candidate_status_id) {
          setValue("candidate_status_id", filterData.candidate_status_id);
        }

      } catch (err) {
        console.error("Error fetching candidate logs:", err);
      }
    }

    if (candidate_id && role_id) {
      fetchLogs();
    }
  }, [candidate_id, role_id]);

  useEffect(() => {
    if (!candidateFilter || !candidateStatuses.length) return;

    // Check if candidate_status_id from filter exists in candidateStatuses options
    const isValidStatus = candidateStatuses.some(
      (cs) => cs.value === candidateFilter.candidate_status_id
    );

    if (isValidStatus) {
      setValue("candidate_status_id", candidateFilter.candidate_status_id);
    } else {
      setValue("candidate_status_id", candidateStatuses[0].value);
    }
  }, [candidateFilter, candidateStatuses]);

  useEffect(() => {
    if (!candidateFilter || !masterStatuses.length) return;

    const matchedMaster = masterStatuses.find(
      (ms) =>
        ms.label.toLowerCase() ===
        (candidateFilter.master_status || "").toLowerCase()
    );

    if (matchedMaster) {
      setSelectedMasterStatus(matchedMaster.value);
    }
  }, [candidateFilter, masterStatuses]);

  useEffect(() => { 
    if (!candidateFilter) return;
    const originalStatus = candidateFilter.candidate_status_id;
    const selectedStatus = parseInt(watchStatus);
    if (selectedStatus === originalStatus) {
      setValue("new_status", "update");
    } else {
      setValue("new_status", "new");
    }
  }, [watchStatus, candidateFilter, setValue]);

// ------------------------Pritam Change Code Start--------------------------------------------- 
const fileList = Array.isArray(files) ? files : Object.values(files || {});

  const role_details = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/roles/fetch_role_data/${role_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.role_data[0].dossier == 1) setReqDossier(true);
    } catch (error) {
      console.log(error);
    }
  };  

  const get_basic_data = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/workstation/get_basic_data_edit_status_form/${role_id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetch_filter_log = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/workstation/fetch_filter_log/${candidate_id}/${role_id}/${watchStatus}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLogData(response.data);
      console.log('filter Data:',response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const get_comp = async () => {
    try {
      const respone = await axios.get(
        `${API_BASE_URL}/candidates/current_compensation/${candidate_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (respone.data.compensation[0]?.comp_id != null) setHasComp(true);
    } catch (error) {
      console.log(error);
    }
  };

  const loadData = async () => {
    try {
      // setGlobalLoading(true);
      await Promise.all([
        fetch_filter_log(),
        role_details(),
        get_basic_data(),
        get_comp(),
      ]);
    } catch (err) {
      console.log(err);
    } finally {
      setGlobalLoading(false);
    }
  };
  
 useEffect(() => {
   if (candidate_id && role_id && watchStatus) { loadData();}
    setEvaluation(false);
    setTimediv(false);
    setShowResume(false);
    setShowDossier(false);
    setBackgroundCheck(false);
    setCandidateClosed(false);
    setMeetingWith(false);
    setMeetingPlace(false);
    setCompReq(false);
    
    if ([28, 29, 30].includes(Number(watchStatus))) {
      setEvaluation(true);
    }
    if ([28, 29, 30, 43, 45, 54].includes(Number(watchStatus))) {
      setTimediv(true);
    } 
    if (Number(watchStatus) == 54) {
      setCandidateClosed(true);
    }
    if ([27, 28, 29, 30, 31, 32, 33, 42, 43, 44, 45, 46, 47, 48, 49, 50, 54].includes(Number(watchStatus))) {
      setShowResume(true);
    }
    if ([33, 42, 43, 44, 45, 46, 47, 48, 49, 50, 54].includes(Number(watchStatus))) {
      setShowDossier(true);
    } 
    if (Number(watchStatus) == 48) {
      setBackgroundCheck(true);
    }
    if ([43, 45].includes(Number(watchStatus))) {
      setMeetingWith(true);
    }
    if (Number(watchStatus) == 45) {
      setMeetingPlace(true);
    }
    if (Number(watchStatus) == 33 || (Number(watchStatus) >= 42 && Number(watchStatus) <= 54)) {
      setCompReq(true);
    }
  }, [candidate_id, role_id, watchStatus]);

   useEffect(() => {
    const $action_by_id_others = $("select[name='action_by_id_others']");
    const $clientName = $("select[name='clientName']");

    $action_by_id_others.select2({
      placeholder: "Select Members",
      width: "100%",
      closeOnSelect: false,
    });

    $clientName.select2({
      placeholder: "Select Interviewers",
      width: "100%",
      closeOnSelect: false,
    });

    $action_by_id_others.on("change", function (e) {
      const selectedValues = $(this).val();
      setValue("action_by_id_others", selectedValues);
    });

    $clientName.on("change", function (e) {
      const selectedValues = $(this).val();
      setValue("clientName", selectedValues);
    });

    return () => {
      $action_by_id_others.select2("destroy");
      $clientName.select2("destroy");
    };
  }, [data]);

  useEffect(() => {
    const $action_by_id_others = $("select[name='action_by_id_others']");
    const $clientName = $("select[name='clientName']");

    $action_by_id_others.select2({
      placeholder: "Select Members",
      width: "100%",
      closeOnSelect: false,
    });

    $clientName.select2({
      placeholder: "Select Interviewers",
      width: "100%",
      closeOnSelect: false,
    });

    // Listen for changes to update React Hook Form
    $action_by_id_others.on("change", function () {
      const selectedValues = $(this).val()?.map(Number) || [];
      setValue("action_by_id_others", selectedValues);
    });

    $clientName.on("change", function () {
      const selectedValues = $(this).val()?.map(Number) || [];
      setValue("clientName", selectedValues);
    });

    return () => {
      $action_by_id_others.select2("destroy");
      $clientName.select2("destroy");
    };
  }, [setValue]);

  useEffect(() => {
    if (LogData && data) {
      const acLogData = LogData?.filter_log?.[0];
      const candidate_filters = LogData?.candidate_filters?.[0];
      const action_by_id_others = acLogData?.action_by_id_others?.split(",").map((id) => parseInt(id)) || [];
      
      const candidate_interviews = LogData?.candidate_interviews?.[0]?.interviewpanel_id?.split(",") || [];
      const interviewpanelIds = candidate_interviews.map((i) => parseInt(i));
      setValue("date", acLogData?.date || "");
      setValue("time", acLogData?.time || "");
      setValue("comments", acLogData?.comments || "");
      
    if (CandidateClosed !== false) {
      setValue("candidate_type", candidate_filters?.candidate_type || "");
      console.log("again");
    }
    console.log('checking ....', LogData?.contribution);
    // if (
    //   LogData?.contribution !== null &&
    //   LogData?.contribution !== undefined &&
    //   LogData?.contribution === 1
    // ) {
    //   setContribution(true);
    // }
    if (Number(LogData?.contribution) === 1) {
        setContribution(true);
      } else {
        setContribution(false);
        setShowContributionForm(false);
      }

      // Timezone dropdown
      const tzMatch = data?.timezones?.find(
        (tz) => parseInt(tz.id) === parseInt(acLogData?.timezone_id)
      );
      if (tzMatch) setValue("timezone_id", tzMatch.id);
      // Single select (action_by_id)
    const userMatch = data?.users?.find(
      (user) => user.id === acLogData?.action_by_id
    );
    if (userMatch) setValue("action_by_id", userMatch.id);

    setValue("clientPlace", candidate_interviews?.[0]?.clientPlace || "");

      // Apply values to Select2 UI
      $("select[name='action_by_id_others']")
        .val(action_by_id_others)
        .trigger("change");

      $("select[name='clientName']").val(interviewpanelIds).trigger("change");
    }
  }, [LogData, data]);
  

  // const onSubmit = async (data) => {
  // if (!HasComp && CompReq) {
  //     alert("Candidate Current Comp is Required");
  //     return;
  //   }  
  //   console.log('CandidateClosed:',CandidateClosed);
  //   console.log('Contribution:',Contribution);
  // if (CandidateClosed && !Contribution) {
  //     setShowContributionForm(true);
  //     return;
  //   }  
  // const formData = new FormData();

  // Object.keys(data).forEach((key) => {
  //   const value = data[key];

  //   if (value === "" || value === null || value === "null" || value === undefined) {
  //     return;
  //   }

  //   if (value instanceof FileList) {
  //     if (value.length > 0) formData.append(key, value[0]);
  //   } else {
  //     formData.append(key, value);
  //   }
  // });

  // try {
  //   setGlobalLoading(true);

  //   const response = await axios.post(
  //     `${API_BASE_URL}/candidates/update_candidate_status_data`,
  //     formData,  // <-- SEND DIRECTLY
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "multipart/form-data",
  //       },
  //     }
  //   );

  //   toastr.success("User status update successfully!");
  //   setTimeout(() => navigate(`/candidates/edit_status/${role_id}/${candidate_id}`), 1000);

  // } catch (err) {
  //   console.error("Submission failed:", err);
  //   alert("Error updating User.");
  // } finally {
  //   setGlobalLoading(false);
  // }
  // };


const submitCandidateStatus = async (data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    const value = data[key];

    if (
      value === "" ||
      value === null ||
      value === "null" ||
      value === undefined
    ) {
      return;
    }

    if (value instanceof FileList) {
      if (value.length > 0) {
        formData.append(key, value[0]);
      }
    } else {
      formData.append(key, value);
    }
  });

  try {
    setGlobalLoading(true);

    const response = await axios.post(
      `${API_BASE_URL}/candidates/update_candidate_status_data`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      toastr.success("User status update successfully!");

      setTimeout(() => {
        navigate(`/candidates/edit_status/${role_id}/${candidate_id}`);
      }, 1000);
    }
  } catch (err) {
    console.error("Submission failed:", err);
    alert("Error updating User.");
  } finally {
    setGlobalLoading(false);
  }
};

const onSubmit = async (data) => {
  if (!HasComp && CompReq) {
    alert("Candidate Current Comp is Required");
    return;
  }

  console.log("CandidateClosed:", CandidateClosed);
  console.log("Contribution:", Contribution);
  console.log("Has Workers:", LogData?.hasWorkers);
  console.log("check designation:",);
  // Candidate is being closed and contribution has NOT been added
  if (CandidateClosed && Number(LogData?.hasWorkers) === 1 && !Contribution && users.designation_id <= 4) {
    setShowContributionForm(true);
    return;
  }
  // Contribution already exists OR candidate isn't being closed
  await submitCandidateStatus(data);
};

useEffect(() => {
  if (newStatus === "new") {
    setValue("comments", ""); 
  } else if (newStatus === "update") {
    setValue("comments", candidateFilter?.comments || ""); 
  }
}, [newStatus, candidateFilter, setValue]);

useEffect(() => {
  if (!candidates) return;

  reset({
    candidate_filter_id: candidateFilter?.candidate_filter_id || "",
    filter_log_id: candidateFilter?.filter_log_id || "",
    role_id,
    company_id: candidateFilter?.company_id,
    candidates_id: candidates.id,
    linkdin_url: candidates.linkdin_url || "",
    phone: candidates.phone?.trim() === "" ? null : candidates.phone,
    email: candidates.email?.trim() === "" ? null : candidates.email,
    gender: candidates.gender?.trim() === "" ? null : candidates.gender,
    dutymaster_id: candidates.dutymaster_id || "",
    duty_id: candidates.duty_id || "",
    new_status: "update"
  });
}, [candidates, candidateFilter]);

// ------------------------Pritam Change Code End--------------------------------------------- 
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header">
            <h5>Candidate Edit status Form
               {CompReq && (
                    <i
                      onClick={() => { setGlobalLoading(true); setCompModel(true);}}
                      title={`${HasComp ? "Update" : "Add"} Compensation`}
                      style={ HasComp ? { cursor: "pointer" } : { animation: "blink 3s infinite", cursor: "pointer",}}
                      className="fa-solid fa-circle-exclamation ms-1 badge bg-info"
                    >
                      <span className="fs-10">
                        {HasComp ? " Update" : " Add"} Compensation
                      </span>
                    </i>
                  )}
            </h5>
          </div>
          {compModel && (
              <CompensationAdd
                candidate_id={candidate_id}
                onClose={(status) => {
                  if (status == 1) {
                    setHasComp(true);
                  }
                  setCompModel(false);
                  loadData();
                }}
              />
            )}
          {newInterviewerModel && (
              <NewInterviewer
                role_id={role_id}
                onClose={(status) => {
                  if (status === 1) {
                    get_basic_data();
                  }
                  setNewInterviewerModel(false);
                  loadData();
                }}
              />
            )}
          {showContributionForm && (
              <ContributionForm
                role_id={role_id}
                candidate_id={candidate_id}
                onClose={(status) => {
                  if (status === 1) {
                    toastr.success("Contribution Added Successfully");
                    setContribution(true);
                  }
                  setShowContributionForm(false);
                  loadData();
                }}
              />
            )}  
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <h5>{candidates?.full_name || "Loading..."}</h5>
              <div className="row">
                <div className="col-md-6">
                  {/* LinkedIn */}
                  <div className="mb-3">
                    <label className="form-label">Linkedin URL</label>
                    <input type="text" {...register("linkdin_url")} readOnly className={`form-control ${ errors.linkdin_url && "is-invalid"}`} />
                  </div>
                  <div className="row">
                   {/* Email */}
                  <div className="mb-3 col-md-4 col-sm-4">
                    <label className="form-label">Email</label>
                      {/* <input type="text" {...register("email", { required: "required" })} className={`form-control ${ errors.email && "is-invalid"}`} /> */}
                      <input type="text" 
                      {...register("email", { validate: (value) => {if (selectedMasterStatus === 1) return true;
                          if (!value) return "Email is required";
                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                              return emailRegex.test(value) || "Invalid email format";
                            }
                          })}
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                          />
                  </div>
                  {/* Phone */}
                  <div className="mb-3 col-md-4 col-sm-4">
                    <label className="form-label">Phone</label>
                    <input type="text"
                      {...register("phone", {
                        validate: (value) =>
                          selectedMasterStatus !== 1
                            ? value?.trim() !== "" || "Phone is required"
                            : true
                      })}
                      className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                    />
                  </div>

                  {/* Gender */}
                  <div className="mb-3 col-md-4 col-sm-4">
                    <label className="form-label">Gender</label>
                      <select {...register("gender")} className="form-select">
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </select>
                  </div> 
                  </div>
                  <div className="row">
                    {/* Major Function */}
                    <div className="mb-3 col-md-4 col-sm-4">
                      <label className="form-label">Major Function*</label>
                        <select className={`form-select ${errors.dutymaster_id ? "is-invalid" : ""}`}
                          {...register("dutymaster_id", { required: true, onChange: (e) => {
                          setSelectedMajor(e.target.value); setSelectedMinorFunctions([]);
                          }})}>
                            <option value={""}>Select Major Function</option>
                            {majorFunctions?.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                            ))}
                        </select>
                    </div>

                  {/* Minor Functions */}
                  <div className="mb-3 col-md-8 col-sm-8">
                    <label className="form-label">Minor Functions*</label>
                    <Select {...register("duty_id", { required: true,})}
                      isMulti
                      options={minorFunctions}
                      value={selectedMinorFunctions}
                      onChange={(sel) => setSelectedMinorFunctions(sel)}
                      classNamePrefix="select"
                      placeholder="Select Minor Functions"
                    />
                  </div>  
                  </div>
                  {/* Source */}
                  {/* <div className="mb-3">
                    <label className="form-label">Source</label>
                    <select
                      className="form-select"
                      value={candidates?.source || ""}
                    >
                      <option value="">Select Source</option>
                      {allSources.map((src) => (
                        <option key={src} value={src}>
                          {src}
                        </option>
                      ))}
                    </select>
                  </div> */}
                </div>

                <div className="col-md-6">
                  <input type="hidden" {...register("role_id")} />
                  <input type="hidden" {...register("company_id")} />
                  <input type="hidden" {...register("candidate_filter_id")} />
                  <input type="hidden" {...register("filter_log_id")} />
                  {/* New/Update Status */}
                  <div className="mb-3">
                    <label className="form-label">New/Update Status</label>
                    <select {...register("new_status")} className="form-select">
                        <option value="update">Update Comments / Edit current client meeting</option>
                        <option value="new">New Comments / New client meeting</option>
                      </select>
                  </div>
                  <div className="row">
                  {/* Master Status */}
                  <div className="mb-3 col-md-6 col-sm-6">
                    <label className="form-label">Master Status</label>
                    <select {...register("master_status_id")}
                      className="form-select"
                      value={selectedMasterStatus}
                      onChange={(e) => {
                        setSelectedMasterStatus(e.target.value);
                        setValue("candidate_status_id", "");
                      }}
                    >
                      {masterStatuses.map((ms) => (
                        <option key={ms.value} value={ms.value}>
                          {ms.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Candidate Status */}
                  <div className="mb-3 col-md-6 col-sm-6">
                    <label className="form-label">Candidate Status</label>
                    <select {...register("candidate_status_id")}
                      className="form-select"
                      disabled={!candidateStatuses.length}
                    >
                      {candidateStatuses.map((cs) => (
                        <option key={cs.value} value={cs.value}>
                          {cs.label}
                        </option>
                      ))}
                    </select>
                  </div>
                   </div> 
                   <div className="row">
                    {showResume && (
                            <div className={`${ backgroundCheck ? "mb-3 col-md-4 col-sm-4" : "mb-3 col-md-6 col-sm-4" }`}>
                                  <div className="mb-2">
                                    <h6 className="mb-1">
                                      Upload Resume{" "}
                                      <span className="text-danger">
                                        {LogData?.resume?.length <= 0 && (
                                          <>* {errors.userfile?.message}</>
                                        )}
                                      </span>
                                    </h6>
                                  </div>
                                  <div className="profile-uploader d-flex align-items-center">
                                    <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                      Upload
                                      <input
                                        {...register("userfile", {required: LogData?.resume?.length <= 0 && "required",})}
                                        type="file" className="form-control image-sign"
                                      />
                                    </div>
                                   {LogData?.resume?.length > 0 && (
                                        <a href={`${API_BASE_URL}/files/candidates/media/${LogData?.resume[0].savename}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-success">
                                          <i className="fa fa-file-pdf"></i> View File
                                        </a>
                                    )}
                                  </div>
                                  <p className="fs-12">
                                      File should be below 4 mb.
                                    </p>
                                </div>
                          )}
                    {showDossier && (
                            <div className={`${ backgroundCheck ? "mb-3 col-md-4 col-sm-4" : "mb-3 col-md-6 col-sm-4" }`}>
                                     <label className="form-label">
                                      Dossier{" "}
                                      {ReqDossier && (
                                        <span className="text-danger">
                                          {LogData?.dossier?.length <= 0 && (
                                            <>* {errors.userfile1?.message}</>
                                          )}
                                        </span>
                                      )}</label>
                                  <div className="profile-uploader d-flex align-items-center">
                                    <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                      Upload
                                      <input
                                        type="file"
                                        className="form-control image-sign"
                                        {...register("userfile1", {
                                          required:
                                            ReqDossier &&
                                            LogData?.dossier?.length <= 0
                                              ? "required"
                                              : "",
                                        })}
                                      /> 
                                    </div>
                                    {LogData?.dossier?.length > 0 && (
                                          <a href={`${API_BASE_URL}/files/candidates/media/${LogData?.dossier[0].savename}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-success">
                                            <i className="fa fa-file-pdf"></i> View File
                                          </a>
                                      )}
                                  </div>
                                  <div className="fs-12">File should be below 4 mb</div>
                            </div>
                          )}
                    {backgroundCheck && (
                            <div className="mb-3 col-md-4 col-sm-4">
                                <div className="profile-upload">
                                  <div className="mb-2">
                                    <h6 className="mb-1">
                                      Background File
                                      <span className="text-danger">
                                        {LogData?.background?.length <= 0 && (
                                          <>* {errors.userfile2?.message}</>
                                        )}
                                      </span>
                                    </h6>
                                  </div>
                                  <div className="profile-uploader d-flex align-items-center">
                                    <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                      Upload
                                      <input
                                        type="file"
                                        className="form-control image-sign"
                                        {...register("userfile2", {
                                          required:
                                            LogData?.background?.length <= 0 &&
                                            "required",
                                        })}
                                      />
                                    </div>
                                    {LogData?.background?.length > 0 && (
                                      <a href={`${API_BASE_URL}/files/candidates/media/${LogData?.background[0].savename}`} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-success">
                                        <i className="fa fa-file-pdf"></i> View File
                                      </a>
                                    )}
                                  </div>
                                </div>
                                <p className="fs-12"> File should be below 4 mb</p>
                              </div>
                          )}      
                   </div>
                    {timediv && (
                      <div className="row">
                          <div className="mb-3 col-md-3 col-sm-3">
                            <label className="form-label">
                              {CandidateClosed ? "Date of Joining" : "Date"}{" "}
                              <span className="text-danger">
                                * {errors?.date?.message}
                              </span>
                            </label>
                            <input
                              type="date"
                              {...register("date", {
                                required: "Required",
                              })}
                              className="form-control"
                            />
                          </div>
                        {!CandidateClosed && (
                            <div className="mb-3 col-md-3 col-sm-3">
                              <label className="form-label">
                                Time{" "}
                                <span className="text-danger">
                                  * {errors?.time?.message}
                                </span>
                              </label>
                              <input
                                type="time"
                                {...register("time", {
                                  required: "Required",
                                })}
                                className="form-control"
                              />
                            </div>
                        )}
                          <div className="mb-3 col-md-3 col-sm-3">
                            <label className="form-label">
                              Time Zone
                              <span className="text-danger">
                                * {errors?.timezone_id?.message}
                              </span>
                            </label>
                            <select
                              {...register("timezone_id", {
                                required: "Required",
                              })}
                              className="form-select"
                            >
                              <option value="">Select Time Zone</option>
                              {data?.timezones?.map((item) => (
                                <option value={item.id} key={item.id}>
                                  {`${item.timezone} (${item.utc})`}
                                </option>
                              ))}
                            </select>
                          </div>
                        {CandidateClosed && (
                            <div className="mb-3 col-md-3 col-sm-3">
                              <label className="form-label">
                                Candidate Type
                                <span className="text-danger">
                                  * {errors?.candidate_type?.message}
                                </span>
                              </label>
                              <select
                                {...register("candidate_type", {
                                  required: "Required",
                                })}
                                className="form-select"
                              >
                                <option value={""}>Select </option>
                                <option value="Not Applicable">
                                  Not Applicable
                                </option>
                                <option value="Cross Border">
                                  Cross Border
                                </option>
                                <option value="Returning Natives">
                                  Returning Natives
                                </option>
                              </select>
                            </div>
                        )}
                      </div>
                    )}
                    {Evaluation && (
                      <div className="row">
                        <div className="col-xxl-6 col-lg-6 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              {watchStatus === 30
                                ? "Meeting With"
                                : "Evaluation by"}{" "}
                              <span className="text-danger">
                                * {errors?.action_by_id?.message}
                              </span>
                            </label>
                            <select {...register("action_by_id", { required: "Required", })} className="form-select">
                              <option value="">Please Select</option>
                              {data?.users?.map((item) => (
                                <option value={item.id} key={item.id}>
                                  {`${item.firstname} ${item.lastname}`}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-xxl-6 col-lg-6 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Other Members
                            </label>
                            <select {...register("action_by_id_others")} multiple className="form-select">
                              <option value="">Please Select</option>
                              {data?.users?.map((item) => (
                                <option value={item.id} key={item.id}>
                                  {`${item.firstname} ${item.lastname}`}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                      </div>
                    )}
                    {MeetingWith && (
                          <div className="row">
                            <div className={`mb-3 col-sm-6`}>
                              <label className="form-label">
                                Meeting With{" "}
                                <span className="fs-12">
                                  <i className="text-primary">
                                    Not In List -{" "}
                                    <a
                                      onClick={() =>
                                        setNewInterviewerModel(true)
                                      }
                                      className="btn btn-sm btn-primary fs-10"
                                    >
                                      Add New
                                    </a>
                                  </i>
                                  <span className="text-danger">
                                    {errors.clientName?.message}
                                  </span>
                                </span>
                              </label>
                              <select
                                {...register("clientName", {
                                  required: "Required",
                                })}
                                className="form-select"
                                multiple
                              >
                                <option value="">Please Select</option>
                                {data?.interview?.map((item) => (
                                  <option value={item.id} key={item.id}>
                                    {`${item.firstname} ${item.lastname}`}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {meetingPlace && data?.interview?.length > 0 && (
                              <div className="col-sm-6">
                                <label className="form-label mb-3">
                                  Meeting Place{" "}
                                  <span className="text-danger">
                                    {errors.clientPlace?.message}
                                  </span>
                                </label>
                                <input
                                  {...register("clientPlace", {
                                    required: "Required",
                                  })}
                                  type="text"
                                  className="form-control"
                                />
                              </div>
                            )}
                          </div>
                        )}
                  <div className="mb-3">
                    <label className="form-label">
                                Add Notes{" "}
                                {!([28, 29, 30].includes(Number(watchStatus))) && (
                                  <span className="text-danger"> * {errors.comments?.message}</span>
                                )}
                              </label>
                    <textarea
                        {...register("comments", {
                          required: !([28, 29, 30].includes(Number(watchStatus))) ? "Required" : false,
                        })}
                        className="form-control"
                      ></textarea>
                  </div>
                </div>
              </div>



              <div className="text-end">
                <button type="button" className="btn btn-secondary me-2" onClick={() => navigate(`/candidates/view/${candidate_id}`)}>
                  <i className="fa fa-arrow-left me-1"></i>
                  Back to Candidate
                </button>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditStatus;
